import Swiper from './Swiper.vue';
export default Swiper;
